module.exports = __webpack_public_path__ + "img/swiper_06.436d54c3.jpg";